const title = "Frequently Asked Questions (FAQs) – Team Banner Sports";

export {title}